import { render } from "./OrangeButton.vue?vue&type=template&id=6d8256e6"
import script from "./OrangeButton.vue?vue&type=script&lang=js"
export * from "./OrangeButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__